import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './HomePage.css';
import logo from '../assets/teesergolf-logo.png';
import Navigation from '../components/Navigation';

function HomePage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handleSearchClick = () => {
    if (isAuthenticated()) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="homepage">
      {/* Navigation Header */}
      <Navigation />

      {/* Hero Section */}
      <header className="hero">
        <div className="hero-content">
          <div className="logo-container">
            <img src={logo} alt="TeeserGolf" className="logo" />
          </div>
          <p className="tagline">Find Your Perfect Tee Time</p>
          <p className="subtitle">
            Search multiple golf courses at once and discover the best available tee times for your schedule
          </p>
          <button className="cta-button" onClick={handleSearchClick}>Search Tee Times</button>
        </div>
      </header>

      {/* Features Section */}
      <section className="features">
        <h2>Why Choose TeeserGolf?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🔍</div>
            <h3>Search Multiple Courses</h3>
            <p>Browse tee times from numerous golf courses all in one place</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⏰</div>
            <h3>Real-Time Availability</h3>
            <p>See up-to-date availability across all partner courses instantly</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💰</div>
            <h3>Compare Prices</h3>
            <p>Find the best rates and make informed decisions</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Personalized Results</h3>
            <p>Filter by date, time, number of players, and specific courses</p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Set Your Preferences</h3>
            <p>Choose your preferred date, time, and number of players</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Search Courses</h3>
            <p>We search multiple booking platforms simultaneously</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Book Your Time</h3>
            <p>View available times and prices, then book with confidence</p>
          </div>
        </div>
      </section>

      {/* Course Images Placeholder Section */}
      <section className="courses-showcase">
        <h2>Discover Amazing Courses</h2>
        <div className="courses-grid">
          <div className="course-image-placeholder">
            <p>Course Photo 1</p>
          </div>
          <div className="course-image-placeholder">
            <p>Course Photo 2</p>
          </div>
          <div className="course-image-placeholder">
            <p>Course Photo 3</p>
          </div>
          <div className="course-image-placeholder">
            <p>Course Photo 4</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Ready to Find Your Tee Time?</h2>
        <p>Start searching for available tee times at top golf courses today</p>
        <button className="cta-button-secondary" onClick={handleSearchClick}>Get Started</button>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="TeeserGolf" className="footer-logo-img" />
          </div>
          <p>&copy; 2024 TeeserGolf. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;
